import { useContext } from 'react';

import { AppEventEmitter } from '../app-event-emitter';
import { AppEventEmitterContext } from '../contexts/app-event-emitter.context';

export const useAppEvents = <E>() => {
  return useContext(AppEventEmitterContext) as AppEventEmitter<E>;
};
